export const createModel = <T>(Model: new (...args: Array<any>) => T, object: {[key: string]: any}): T => {
    const model: T = new Model();
    try {
        if (object && Object.keys(object).length !== 0) {
            Object.keys(model).forEach((key: string) => {
                model[key] = Object.prototype.hasOwnProperty.call(object, key) ? object[key] : model[key];
            });
        }
    } catch (e) {

    }
    return model;
};
